export default "__VITE_ASSET__dfB3ukaS__"